package one.devsbox.www.tools

import one.devsbox.shared.ads.SharedIO
import one.devsbox.shared.ads.TargetType

class PermissionWrapperEditor(private val permission: SharedIO.Permission) {

    val user = Item(TargetType.USER, permission)
    val media = Item(TargetType.RESOURCE, permission)
    val device = Item(TargetType.DEVICE, permission)
    val location = Item(TargetType.LOCATION, permission)
    val campaign = Item(TargetType.CAMPAIGN, permission)
    val company = Item(TargetType.COMPANY, permission)
    val application = Item(TargetType.APPLICATION, permission)

    class Item(target: TargetType, permission: SharedIO.Permission) {
        val read = EFieldMaskInt(permission::read, target.mask)
        val write = EFieldMaskInt(permission::write, target.mask)
        val delete = EFieldMaskInt(permission::delete, target.mask)

        override fun toString(): String {
            return buildString {
                append("R:${read.state};")
                append("W:${write.state};")
                append("D:${delete.state}")
            }
        }
    }

    override fun toString(): String {
        return buildString {
            appendLine("GLOBAL")
            appendLine("read: ${permission.read}")
            appendLine("write: ${permission.write}")
            appendLine("delete: ${permission.delete}")
            appendLine("INDIVIDUAL")
            appendLine("media: $media")
            appendLine("campaign: $campaign")
            appendLine("device: $device")
            appendLine("location: $location")
            appendLine("user: $user")
        }
    }
}

fun SharedIO.Permission.editor() = PermissionWrapperEditor(this)



